import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import Listen from "@/pages/Listen";
import Studio from "@/pages/Studio";

document.documentElement.classList.add("dark");

const AuthShell = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center px-4 py-10" data-testid="auth-page">
    <div className="flex flex-col items-center gap-6">
      <Link to="/" className="font-display text-4xl chrome-text" data-testid="auth-home-link">Lowride Life Radio</Link>
      {children}
    </div>
  </div>
);

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/" element={<Listen />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/sign-in/*" element={<AuthShell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthShell>} />
            <Route path="/sign-up/*" element={<AuthShell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthShell>} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
